"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTemplateSystemType = void 0;
var EmailTemplateSystemType;
(function (EmailTemplateSystemType) {
    EmailTemplateSystemType[EmailTemplateSystemType["MeetingCalendarInvite"] = 1] = "MeetingCalendarInvite";
})(EmailTemplateSystemType || (exports.EmailTemplateSystemType = EmailTemplateSystemType = {}));
